import z from 'zod';
import {studyDbSchema} from './studyDbSchema';

/** Output schema for use (with id from document id). */
export const studySchema = studyDbSchema.omit({content: true}).extend({
  id: z.string(),
});

export interface Study extends z.infer<typeof studySchema> {}
